import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import pl from './locales/pl.json';
import en from './locales/en.json';

const resources = {
  pl: {
    translation: pl
  },
  en: {
    translation: en
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pl', // Polish as fallback
    defaultNS: 'translation',

    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    },

    react: {
      useSuspense: false
    }
  });

export default i18n;